$(function(){
    if(!$$.isMobile){
        var $items = $(".socials__item");
        $items.each(function(key, item){
            var $item = $(item),
                timer
                ;

            $item
                .mouseenter(function () {
                    timer = setTimeout(function(){
                        $item.find(".socials-tooltip").fadeIn();
                    }, 200);
                })
                .mouseleave(function () {
                    clearTimeout(timer);
                    $(this).find(".socials-tooltip").fadeOut();
                });

        })

    }

    if($$.isMobile){

        $('body').on('click', function(e){
            var $target = $(e.target);
            if(!$target.hasClass('socials__item')){
                $('.socials__item_open').removeClass('socials__item_open');
            }
        });

        $(".socials__item")
            .on('click', function () {

                if($(this).hasClass("socials__item_open")){
                    $(this).removeClass("socials__item_open");
                }else{
                    $(this).closest('.socials').find('.socials__item_open').removeClass("socials__item_open");
                    $(this).addClass("socials__item_open");
                }

            });
    }
});
